// extracted by mini-css-extract-plugin
module.exports = {"title":"SingleContent_title__3cQfd","subTitle":"SingleContent_subTitle__Ts3wB","poster":"SingleContent_poster__riQpm"};